<template>
  <div class="a__contact">
    <div class="w__title">
      <div class="title">
        <h2 class="title">Contact</h2>
        <div class="line"></div>
        <p class="p_content">お問合せ</p>
      </div>
      <hr>
      <div class="content">
        <p  class="text">以下の項目を記入し、「送信する」ボタンを押してください。</p>
        <span>個人情報の取り扱いに関しては「プライバシーポリシー」をお読みいただき、<br>
              同意のうえお問い合わせください。</span>
      </div>
    </div>
      <form v-on:submit.prevent="submitForm" method="post">
        <div class="w__forms">
          <div class="forms">
            <div class="form">
              <p>氏名</p>
              <div>
                <input class="form_name first" type="text" name="name_1" placeholder="山田" v-model="name_1" maxlength="20" required>
                <input class="form_name" type="text" name="name_2" placeholder="太郎" v-model="name_2" maxlength="20" required>
              </div>
            </div>
            <div class="form">
              <p>メールアドレス</p>
              <input type="email" name="mail" placeholder="example@weboar.com" v-model="mail" maxlength="128" required>
            </div>
            <div class="form">
              <p>電話番号</p>
              <input type="text" name="number" placeholder="06-1234-5678" v-model="number" maxlength="15">
            </div>
            <div class="form">
              <p>お問合せ内容</p>
              <textarea name="content" id="content" cols="30" rows="10" v-model="content" required></textarea>
            </div>
            <button type="submit">送信する</button>
          </div>
        </div>
      </form>
  </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
Vue.$http = Axios;

export default {
  data() {
      return{
        name_1: '',
        name_2: '',
        mail:'',
        number:'',
        content:'',
      }
    },
  methods: {
    submitForm: function () {
        console.log('submitting message...');
        Axios.post('https://api.weboar.com/hp/contact', {
          name_1: this.name_1,
          name_2: this.name_2,
          mail: this.mail,
          number: this.number,
          content: this.content
        }).then(function (response) {
          console.log(response);
          alert('お問い合わせを送信しました');
        }).catch(function (error) {
          console.log(error);
          alert('お問い合わせの送信に失敗しました');
        });
      }
  }
}
</script>



<style>

.a__contact {
  width: 100%;
  height: 100%;
  top: -24px;
  position: relative;
  border-left: #d8d8d8 solid 1px;
  padding-bottom: 90px;
}
.a__contact .w__title {
  display: block;
  width: 80%;
  margin: 0 auto;
  max-width: 1250px;
}

.a__contact .w__title .title {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  margin-top: 45px;
}

.a__contact .w__title .title .line {
  width: 1px;
  height: 13px;
  background-color: #f9eadb;
  display: inline-block;
  margin: 40px 18px 0 30px;
}

.a__contact .w__title .title h2.title {
  margin: 24px 0 8px;
  font-size: 30px;
}

.a__contact .w__title p.p_content {
  font-size: 12px;
  color: #555;
}

.a__contact .w__title hr {
  background-color: #f9eadb;
  border-style: none;
  height: 1px;
}

.a__contact .w__title .title .p_content {
  display: inline-block;
  margin-top: 36px;
}

.a__contact .w__title .content {
  margin-top: 40px;
  width: 90%;
  margin: 40px auto 0;
  max-width: 625px;
}

.a__contact .w__title .content .text {
  font-size: 16px;
  color: #333;
  margin-bottom: 34px;
}

.a__contact .w__title .content span {
  font-size: 12px;
  line-height: 1.5;
  color: #333;
}

.w__forms {
  width: 90%;
  margin: 80px auto 0;
}

.w__forms .forms {
  width:90%;
  margin: 0 auto;
  max-width: 625px;
}

.w__forms .forms .form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.w__forms .forms .form p {
  display: inline-block;
  width: 30%;
  font-size: 18px;
  color: #b55746;
  text-align: left;
  margin-top: 10px;
}

.w__forms .forms .form input {
  height: 40px;
  width: 414px;
  border-radius: 8px;
  border: solid 1px #d8d8d8;
  padding-left: 8px;
  font-size: 18px;
  color: #333;
}

.w__forms .forms .form input::placeholder {
  font-size: 18px;
  color: #333;
  opacity: 0.19;
}

.w__forms .forms .form input.form_name {
  width: 194px;
}

.w__forms .forms .form input.first {
  margin-right: 11px;
}

.w__forms .forms .form textarea {
  width: 69%;
  max-width: 413px;
  height: 160px;
  border-radius: 8px;
  border: solid 1px #d8d8d8;
  font-size: 18px;
  padding-left: 8px;
  padding-top: 8px;
  color: #333;
}

.w__forms button {
  display: inline-block;
  margin: 64px 0;
  width: 100%;
  height: 54px;
  border-radius: 27px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(136deg, #fee140, #fdb960 15%, #fcaa6c 33%, #fa709a);
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  border: none;
}

.w__forms button:hover {
  cursor: pointer;
  opacity: 0.9;
}

@media screen and (max-width:1024px) {
  .a__contact {
    margin-top: 48px;
    padding-bottom: 0;
  }
}

@media screen and (max-width: 749px) {
  .a__contact .w__title {
    margin: 50px auto 24px;
    width: 90%;
  }

  .w__forms .forms {
    width: auto;
  }

  .a__contact .w__title .title h2.title {
    font-size: 30px
  }

  .a__contact .w__title .title .line {
    display: none;
  }

  .a__contact .w__title .title .p_content {
    display: none;
  }

  .a__contact .w__title .content {
    margin: 24px auto 0;
    width: 100%;
  }

  .a__contact .w__title .content .text {
    font-size: 14px;
    margin-bottom: 14px;
  }

  .w__forms {
    margin: 36px auto 0;
  }

  .w__forms .forms .form {
    display: block;
  }

  .w__forms .forms .form input.form_name {
    width: 96%;
  }

  .w__forms .forms .form input.first {
    margin-bottom: 8px;
    margin-right: 0;
  }
  .w__forms .forms .form input {
    width: 96%;
  }

  .w__forms .forms .form textarea {
    width: 96%;
    max-width: 96%;

  }

  .w__forms .forms .form p {
    width: 100%;
    font-size: 16px;
    margin: 12px 0 8px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue